import {
  DeployCommand,
  type CommonDeployCommandProps
} from "@/pages/DeploymentsPage/components/molecules/DeployCommand"
import { InlineField } from "@/pages/DeploymentsPage/components/molecules/InlineField"
import { getDefaultValues, getDeployCommand, getLines } from "./helpers"

export const DeploymentAddHelmChartCommand = (
  props: CommonDeployCommandProps
) => {
  const lines = getLines()

  return (
    <DeployCommand
      getDefaultValues={getDefaultValues}
      getDeployCommand={getDeployCommand}
      {...props}
    >
      {(props) => (
        <>
          <InlineField noNullCharacter line={lines["1"]} {...props} />
          <InlineField noNullCharacter line={lines["2"]} {...props} />
        </>
      )}
    </DeployCommand>
  )
}
